

































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { AxiosVue } from '@/AxiosVue';
import Confirmation from '@/components/Confirmation.vue';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import { actionsEvent } from '@/setup';
import { fetchMS } from './fetchMS';
import { Snotify } from '@/snotify/Snotify';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import ModalEditar from '@/pantallas/Asignacion_sitrack/ModalEditar.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    ModalEditar,
    'app-confirmacion': Confirmation,
  },
})
export default class AsignacionSitrack extends Vue {
  @Prop({ default: null }) ID_VEHICULO_SELECCIONADO: any;
  @Prop({ default: null }) LOGINCODE_SELECCIONADO: any;
  @Prop({ default: null }) FLOTA_SELECCIONADO: any;
  @Prop({ default: null }) GRUPOVEHICULO_SELECCIONADO: any;
  @Prop({ default: null }) ID_PATENTE_SELECCIONADO: any;
  @Prop({ default: null }) PLATAFORMA: any;

  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades = Funcionalidades.AsignacionSitrack;
  readonly $snotify: Snotify;
  loadingService = new LoadingService();
  ModalEditar: boolean = false; //controla el estado del modal
  gridApi: GridApi = null;
  LISTA_GRILLA: any = [];
  model_plataformas: any = [];
  lista_plataformas: any = [];
  model_flotas: any = [];
  lista_flotas: any = [];
  model_search: any = null;
  mostrarModalCONFIRMAR: boolean = false;
  Modal_confirmar_TEXTO: any = '';

  constructor() {
    super();
    actionsEvent.onEditar(this.handlerButtonEditar);
    actionsEvent.onEliminar(this.handlerButtonEliminar);
  }

  handlerButtonEliminar(params: ICellRendererParams) {
    if (params.data['CodApiSitrack'] == '') {
      this.$snotify.error('No se puede eliminar un login code vacío');
      return;
    }
    this.ID_VEHICULO_SELECCIONADO = params.data['cod_vehiculo'];
    this.LOGINCODE_SELECCIONADO = params.data['CodApiSitrack'];
    this.ID_PATENTE_SELECCIONADO = params.data['vehiculo'];
    this.FLOTA_SELECCIONADO = params.data['nomflota'];
    this.GRUPOVEHICULO_SELECCIONADO = params.data['grupo'];
    this.PLATAFORMA = params.data['plataforma'];
    this.Modal_confirmar_TEXTO =
      '¿Está seguro que desea eliminar login code ' +
      this.LOGINCODE_SELECCIONADO +
      ' para vehículo: ' +
      this.ID_PATENTE_SELECCIONADO +
      ' ?';
    this.mostrarModalCONFIRMAR = true;
  }

  async confirmCallback(val: boolean) {
    // console.log('confirmCallback', val);
    if (val == true) {
      this.eliminar_logincode();
    } else {
      this.mostrarModalCONFIRMAR = false;
    }
  }

  async eliminar_logincode() {
    this.loadingService.showLoading(undefined, 'deleteLoginCode');
    return fetchMS(
      {
        cod_vehiculo: this.ID_VEHICULO_SELECCIONADO,
        login_code: this.LOGINCODE_SELECCIONADO,
        plataforma: this.PLATAFORMA,
      },
      'sitrack_logincode/deleteLoginCode'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('deleteLoginCode');
        // console.log(data.data);
        if (data.data.STATUS == 'NOK') {
          this.$snotify.error(data.data.MENSAJE);
          return;
        }
        this.$snotify.success(data.data.MENSAJE);
        let a = this.handleBuscarClick();
      })

      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        // Se cierra el modal al finalizar el fetch
        this.mostrarModalCONFIRMAR = false;
        return null;
      });
  }

  handlerButtonEditar(params: ICellRendererParams) {
    this.ID_VEHICULO_SELECCIONADO = params.data['cod_vehiculo'];
    this.LOGINCODE_SELECCIONADO = params.data['CodApiSitrack'];
    this.ID_PATENTE_SELECCIONADO = params.data['vehiculo'];
    this.FLOTA_SELECCIONADO = params.data['nomflota'];
    this.GRUPOVEHICULO_SELECCIONADO = params.data['grupo'];
    this.PLATAFORMA = params.data['plataforma'];
    this.ModalEditar = true;
    // console.log(this.ID_VEHICULO_SELECCIONADO);
  }

  async handleBuscarClick() {
    this.LISTA_GRILLA = await this.get_grid_data();
    // console.log('handleGridReady', this.LISTA_GRILLA);
    this.gridApi.setRowData(this.LISTA_GRILLA);
    this.gridApi.setDomLayout('autoHeight');
  }

  async ModalEditar_callback(event: any) {
    // console.log('ModalEditar_callback', event);
    let a = await this.handleBuscarClick();
    if (!event) {
      this.gridApi.paginationGoToPage(0);
    }
    this.ModalEditar = event;
  }

  async mounted() {
    await this.get_plataformas();
  }

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Login Code',
        field: 'CodApiSitrack',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha ingreso',
        field: 'InsDt',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Patente',
        field: 'vehiculo',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Código vehículo',
        field: 'cod_vehiculo',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Código flota',
        field: 'cod_flota',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      // {
      //   headerName: 'Cod. Grupo Vehículo',
      //   field: 'cod_grupovehiculo',
      //   hide: false,
      //   resizable: true,
      //   cellStyle: { textAlign: 'left' },
      // },
      // {
      //   headerName: 'Grupo',
      //   field: 'grupo',
      //   hide: false,
      //   resizable: true,
      //   cellStyle: { textAlign: 'left' },
      // },
      {
        headerName: 'Nombre flota',
        field: 'nomflota',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
    ],
    pagination: true,
    paginationPageSize: 30,
    onGridReady: this.handleGridReady,
  };

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionEditar, this.accionEliminar];

  async handleGridReady(event: GridReadyEvent) {
    this.LISTA_GRILLA = await this.get_grid_data();
    // console.log('handleGridReady', this.LISTA_GRILLA);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.LISTA_GRILLA);
    this.gridApi.setDomLayout('autoHeight');
  }

  clearFilters() {
    this.model_flotas = '';
    this.model_plataformas = '';
    this.model_search = '';
  }

  async get_dropdowns() {
    this.loadingService.showLoading(undefined, 'get_dropdowns');
    return fetchMS(
      { plataforma: this.model_plataformas },
      'sitrack_logincode/get_dropdowns'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_dropdowns');
        // console.log(data.data);
        this.lista_flotas = data.data.flotas;
      })

      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_plataformas() {
    this.loadingService.showLoading(undefined, 'get_plataformas');
    return fetchMS({}, 'sitrack_logincode/getPlatforms')
      .then((data: any) => {
        this.loadingService.hideLoading('get_plataformas');
        this.model_plataformas = data.data.data;
        this.lista_plataformas = data.data.data;
      })

      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_grid_data(filter_data: any = null) {
    if (this.model_flotas != '' && this.model_plataformas != '') {
      if (filter_data == null) {
        filter_data = {
          plataforma: this.model_plataformas,
          codFlota: this.model_flotas,
        };
        // Añadir la propiedad 'search' solo si this.model_search no es null ni una cadena vacía
        if (this.model_search != null && this.model_search !== '') {
          filter_data.search = this.model_search;
        }
      }

      this.loadingService.showLoading(undefined, 'getgriddata');
      return fetchMS(filter_data, 'sitrack_logincode/getAllLoginCode')
        .then((data: any) => {
          this.loadingService.hideLoading('getgriddata');
          return data.data.data;
        })

        .catch((error: any) => {
          return null;
        })
        .finally(() => {
          return null;
        });
    } else {
      if (this.model_search != null) {
        this.$snotify.error(
          'Plataforma y flota son necesarios para realizar búsqueda'
        );
      }
    }
  } //end get_grid_data
} //end class
